
<div class="row condition-row">
  <div class="col-1 head">
    <template v-if="isFirstRule">
      <strong>If</strong>
    </template>
    <template v-else>
      <and-or-select v-model="ruleSet.join_type" :outside-modal="outsideModal"></and-or-select>
    </template>
  </div>
  <div class="col">
    <div class="condition-block" :class="outsideModal ? 'p-0' : 'scroll-area'">
      <referenced-controls-select
          class="conditional-rule-control-select"
          v-model="referencedControlId"
          :parent="parent"
          :id="'select-input-' + index"
          :outside-modal="outsideModal"
          :include-built-in-properties="includeBuiltInProperties"
          :key="referencedControlId"></referenced-controls-select>

      <template v-if="referencedControl && referencedControl.isValidForConditionalLogic">
        <template v-if="targetTypes.length > 1" >
          's
          <target-type-select :target-types="targetTypes" v-model="targetType"></target-type-select>
        </template>
        <comparison-select
            v-model="rule.comparison"
            :type="comparisonType"
            :show-is-updated-comparison="showIsUpdatedComparison"
            :show-previous-value-comparison-options="showPreviousValueComparisonOptions"
            :hide-datetime-is-within="hideDatetimeIsWithin"
            :show-presence-based-comparisons="showPresenceBasedComparisons"
            :outside-modal="outsideModal"
            :key="`${comparisonType}${rule.comparison}`"></comparison-select>
        <div v-if="rule.isValueRequired">
          <template v-if="matchFormFields">
            <div class="sr-only">
              <label for="form-field-select" class="a-select-label">Form Field Select</label>
            </div>
            <a-select
              id="form-field-select"
              v-model="rule.value"
              :options="targetReferencedControlOptions"
              > 
            </a-select>
          </template>
          <input v-else-if="comparisonType === ComparisonType.text" type="text" v-model="rule.value" class="xs">
          <input v-else-if="comparisonType === ComparisonType.numeric"
                 type="number" v-model="rule.value" class="xs">
          <input v-else-if="comparisonType === ComparisonType.instanceCount"
                 type="number" v-model="rule.value" class="xs" min="0">
          <referenced-control-options-select
              v-else-if="[ComparisonType.singleChoice, ComparisonType.multiChoice].includes(comparisonType)"
              type="number"
              v-model="rule.value"
              :referenced-control="referencedControl"
              :outside-modal="outsideModal"
              :key="`${rule.client_id}-control-options-select`"
          ></referenced-control-options-select>
          <template
            v-else-if="comparisonType === ComparisonType.datetime"
          >
            <div
              v-if="rule.comparison === DatetimeComparison.isWithin"
              class="d-flex"
            >
              <number-input
                v-model="rule.value"
                :min="1"
                :allow-negatives="false"
                :replacement-value="1"
                class="mr-3"
              />
              <a-select
                v-model="rule.value_duration_unit"
                :options="DurationAndTimeHelper.durationUnitLongOptions"
                :has-teleport="true"
                :key="`${rule.client_id}-duration-unit-select`"
              />
            </div>
            <div v-else class="d-flex">
              <a-select
                v-model="rule.date_type"
                :options="dateTypeOptions"
                :has-teleport="true"
                :key="`${rule.client_id}-date-type-select`"
              />
              <date-picker
                v-if="rule.date_type === 'static'"
                :mode="referencedControl.getConditionDateTimeMode()"
                :min="referencedControl.getConditionMinDateTime()" :max="referencedControl.getConditionMaxDateTime()"
                v-model="rule.value"
              />
              <div v-else class="d-flex">
                <a-select
                  v-model="rule.relative_date_type"
                  :options="relativeDateTypeOptions"
                  :has-teleport="true"
                  :key="`${rule.client_id}-relative-date-type-select`"
                />
                <a-select
                  v-model="rule.relative_date"
                  :options="relativeDateOptions"
                  :has-teleport="true"
                  :key="`${rule.client_id}-relative-date-select`"
                />
              </div>
            </div>
          </template>
          <template v-else-if="comparisonType === ComparisonType.relativeUser">
            <referenced-control-options-select
              type="number"
              v-model="rule.value"
              :referenced-control="referencedControl"
              :outside-modal="outsideModal"
              :key="comparisonType"></referenced-control-options-select>
          </template>
          <template v-else-if="comparisonType === ComparisonType.accountRelation">
            <a-select
              v-model="rule.value"
              :options="accountRelationOptions"
            ></a-select>
          </template>
          <template v-else-if="comparisonType === ComparisonType.accountRelationUser">
            <conditional-rule-user-search
              :value="rule.value"
              :referenced-control="referencedControl"
              :relative-user-text="relativeUserText"
              :referenced_value_id="rule.referenced_value_id"
              @changed="selectedUserChange"></conditional-rule-user-search>
          </template>
        </div>
      </template>

      <div class="cta" v-if="!disallowMultipleConditions" style="margin-right: 15px;">
        <suffix>
          <help-tooltip v-if="comparisonType === ComparisonType.numeric" text="values for percentage formatted fields should be input as decimals. ex: min/max of 20%-100% should be input as .2 and 1"></help-tooltip>
        </suffix>
        <slot name="rule-options" :rule="rule">
          <rule-options :model="rule"></rule-options>
        </slot>
      </div>
    </div>
  </div>
</div>
